import axios from "axios";
import { Base_URL, Base_URL2 } from "../url";

export const saveVendorInvoice = async (invoiceData) => {
  console.log(invoiceData);
  try {
    const response = await axios.post(
      `${Base_URL}/Invoices/InvoicesInserData`,
      invoiceData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save vendor invoice";
  }
};

export const fetchProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projects";
  }
};

export const fetchItems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Item/ItemGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch items";
  }
};

export const fetchInvoicesHeaders = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/VIM_Masters/headers`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.title ||
        "Failed to fetch items",
    );
  }
};

export const fetchInvoiceItems = async (guid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/VIM_Masters/items/${guid}`,
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.title ||
        "Failed to fetch items",
    );
  }
};

export const updateParkStatus = async (payload) => {
  const response = await fetch(
    `${Base_URL}/VIM_Masters/park-status`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );

  return response.json();
};
